import type { ReactNode } from 'react';
import type { Coin, Network } from '@shared/api';
import UsdcIcon from '@assets/icons/crypto/usdc.svg';
import EthIcon from '@assets/icons/crypto/eth.svg';
import BtcIcon from '@assets/icons/crypto/btc.svg';
import UsdtIcon from '@assets/icons/crypto/usdt.svg';
import SolIcon from '@assets/icons/crypto/sol.svg';

const CRYPTO_ICONS: Record<Coin, ReactNode> = {
  ETH: <EthIcon />,
  USDC: <UsdcIcon />,
  BTC: <BtcIcon />,
  SOL: <SolIcon />,
  USDT: <UsdtIcon />,
};

const NETWORK_NAME: Record<Network, string> = {
  ETH: 'Ethereum',
  USDC_ERC20: 'ERC20',
  BTC: 'Bitcoin',
  USDC_SOL: 'Solana',
  SOL: 'Solana',
};

const NETWORK_QR_SCHEME: Record<Network, string> = {
  ETH: 'ethereum',
  USDC_ERC20: 'ethereum',
  BTC: 'bitcoin',
  USDC_SOL: 'solana',
  SOL: 'solana',
};

export class CryptoUtils {
  static getCryptoIcon = (coin: Coin) => CRYPTO_ICONS[coin];

  static getCryptoNetworkName = (network: Network) => NETWORK_NAME[network] ?? network;

  static getCryptoQrValue = (network: Network, address: string) => `${NETWORK_QR_SCHEME[network] ?? network.toLowerCase()}:${address}`;

  static truncateWalletAddress = (address: string, chars = 6) => {
    const prefix = address.startsWith('0x') || address.startsWith('0X') ? 2 : 0;
    if (address.length <= prefix + chars * 2) return address;
    return `${address.slice(0, prefix + chars)}...${address.slice(-chars)}`;
  };
}
